import { instance } from "libs/api";

import { ApiRoutesContent } from "../../constants";
import { SocialsData } from "../../content.types";

export const requestUpdateSocials = async (
  body: SocialsData
): Promise<SocialsData> => {
  return await instance.post(ApiRoutesContent.Socials, body);
};
